import { computed, ref } from 'vue'
import { useStore } from 'vuex'
import ActiveRoleListCard from 'components/ActiveRoleListCard/ActiveRoleListCard.vue'

export default {
    name: "ActiveRolesList",
    components: { 
        ActiveRoleListCard  
    },
    props: {
        rolesData: {
            type: Object,
            required: false
        }
    },
    setup(props){

        const store = useStore()

        const rolesData = ref(props.rolesData ?? [])
        const pendingRoles = computed(()=> rolesData.value.filter(r => !r.isApproved))
        const confirmedRoles = computed(()=> rolesData.value.filter(r => r.isApproved))

        const getLabel = (labelKey) => store.getters['labels/getLabel']({ labelCollection: "ActiveRolesList", labelKey: labelKey })

        return {
            getLabel,
            rolesData,
            pendingRoles,
            confirmedRoles
        }
        
    }
}